import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const GuestMenu: AnyLinkType[] = [
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '{{GAR_CONTACT}}',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '{{SITE_MAP_LINK}}',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
